import Vue from 'vue'
import VueRouter from 'vue-router'

const Home = () => import('@/views/Home');
const Login = () => import('@/views/Login');
const Customers = () => import('@/views/Customers');
const Chat = () => import('@/views/Chat');
const Conversations = () => import('@/views/Conversations');
Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        component: Home,
        redirect: '/conversations',
        children: [
            {
                path: 'conversations',
                components: {
                    default: Conversations
                },
                children: [{
                    path: 'chat/:id',
                    components: {
                        default: Chat
                    }
                }]
            },
            {
                path: 'customers',
                components: {
                    default: Customers
                }
            }
        ]
    },
    {
        path: '/login',
        components: {
            default: Login
        }
    }
];

const router = new VueRouter({
    mode: 'history',
    routes
});

router.beforeEach((to, from, next) => {
    // 检查 URL 参数中是否有自动登录信息
    const urlParams = new URLSearchParams(window.location.search);
    const autoLogin = urlParams.get('autoLogin');
    const userId = urlParams.get('userId');
    const token = urlParams.get('token');
    const userType = urlParams.get('type');
    const shop_id = urlParams.get('shop_id');
    console.log(shop_id)
    // 如果是自动登录模式，且已有用户信息，直接进入主页面
    if (autoLogin === 'true' && userId && token) {
        // 解析用户ID和类型
        const parts = userId.split('-');
        const id = parts[0];
        const type = parts[1] || userType;
        
        // 设置 shopId：平台客服使用 'platform'，商家客服使用 'merchant'（统一命名）
        const shopId = type === 'admin' ? 'platform' : shop_id;

        const agentInfo = {
            id: userId, // 使用完整ID（包含类型）
            name: userType === 'admin' ? '平台客服' : '商家客服',
            type: type,
            token: token,
            originalId: id, // 保存原始ID（不含类型）
            shopId: shopId // GoEasy 需要的 shopId
        };
        
        // 保存到全局数据
        Vue.prototype.globalData.currentAgent = agentInfo;
        
        // 如果访问登录页，重定向到主页
        if (to.path === '/login') {
            next({ path: '/conversations' });
        } else {
            next();
        }
    } else if (to.path !== '/login' && !Vue.prototype.globalData.currentAgent) {
        // 没有自动登录信息且未登录，跳转到登录页
        next({path: '/login'});
    } else {
        next();
    }
});

export default router
